"use client";

import dynamic from "next/dynamic";

const MessengerLanding = dynamic(
  () =>
    import("@/components/messenger-landing").then((m) => ({
      default: m.MessengerLanding,
    })),
  { ssr: false },
);

export function MessengerLandingClient({
  messenger,
}: {
  messenger: "tg" | "max";
}) {
  return <MessengerLanding messenger={messenger} />;
}
